// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles-module__grid___33rP8","gridItem":"styles-module__gridItem___2PYPF","photo":"styles-module__photo___1RlH-","photosSection":"styles-module__photosSection___1bjDh"};